<div *ngIf="listType === phoneNumberList.nameValueListTypes.BLACKLIST_INCOMING">
  <p>{{'blacklist.description' | translate}}</p>
</div>
<div *ngIf="listType === phoneNumberList.nameValueListTypes.BLACKLIST_OUTGOING">
  <p>{{'blacklist.list_description' | translate}}</p>
</div>
<div *ngIf="listType === phoneNumberList.nameValueListTypes.COMPANY_BLACKLIST_OUTGOING">
  <p>{{'blacklist.list_description' | translate}}</p>
</div>

<gt-phone-number-list [listType]="listType" [orgName]="oname" [canEdit]="canEdit" [login]="login">
</gt-phone-number-list>

<div *ngIf="phoneNumberList?.phonenumberEntries?.length === 0 && !canEdit"> 
  {{'blacklist.none_blocked' | translate}}
</div>

<mat-slide-toggle class="settingsButton"
                  [(ngModel)]="blockCLIR"
                  *ngIf="phoneNumberList.nameValueListTypes.BLACKLIST_INCOMING === listType"
                  [disabled]="!canEdit"
                  (ngModelChange)="changeBlockCLIR()">{{'blacklist.block_hidden_numbers' | translate}}
</mat-slide-toggle>
